import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DataService } from '../data.service';
import { FormControl, NgForm, ValidatorFn, AbstractControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { Trasllat } from '../lib/model/trasllat';
import { Pais } from '../lib/model/pais';
import { Localitat } from '../lib/model/localitat';
import { Utilitats } from '../lib/utilitats';
import { MatStepper, MatSnackBar } from '@angular/material';
import { BLTrasllat } from '../lib/bl/bltrasllat';
import { Alumne } from '../lib/model/alumne';
import { BLEnum } from '../lib/bl/blenum';
import { Enum } from '../lib/model/enum';
import { I18n } from '@ngx-translate/i18n-polyfill';

@Component({
  selector: 'app-dades-personals',
  templateUrl: './dades-personals.component.html',
  styleUrls: ['./dades-personals.component.css'],
  providers: [BLTrasllat, BLEnum]
})
export class DadesPersonalsComponent implements OnInit {

  @ViewChild('formulari') formulari: NgForm;
  @Input() stepper: MatStepper;
  trasllat: Trasllat;
  tipusDocuments: Enum[];
  sexes: Enum[];
  stepPerformed = false;
  dateFormat = this.i18n('dd/MM/yyyy');

  tipusDocumentIdentificatiuInput: FormControl;
  nacionalitatCtrl: FormControl;
  paisNaixementCtrl: FormControl;
  poblacioNaixementCtrl: FormControl;

  filteredNacionalitats: Observable<Pais[]>;
  filteredPaisosNaixement: Observable<Pais[]>;
  filteredPoblacionsNaixement: Observable<Localitat[]>;

  constructor(public dataService: DataService,
              public utilitats: Utilitats,
              public blTrasllat: BLTrasllat,
              public blEnum: BLEnum,
              public snackBar: MatSnackBar,
              public i18n: I18n) {
    this.trasllat = this.dataService.trasllat;
    this.tipusDocumentIdentificatiuInput = new FormControl('', [], this.validateDocumentIdentificatiu.bind(this));
    this.nacionalitatCtrl = new FormControl();
    this.filteredNacionalitats = this.nacionalitatCtrl.valueChanges
        .startWith(null)
        .map(x => x ? this.dataService.filtraPaisos(x) : this.dataService.paisos);

    this.paisNaixementCtrl = new FormControl();
    this.filteredPaisosNaixement = this.paisNaixementCtrl.valueChanges
        .startWith(null)
        .map(x => x ? this.dataService.filtraPaisos(x) : this.dataService.paisos);

    this.poblacioNaixementCtrl = new FormControl();
    this.filteredPoblacionsNaixement = this.poblacioNaixementCtrl.valueChanges
        .startWith(null)
        .map(x => {
            if (x != null && x.length > 1) {
              return this.dataService.filtraPoblacions(x);
            } else {
              return this.dataService.poblacions.slice(0, 250);
            }
          });
   }

   async ngOnInit() {
    await this.loadTipusDocuments();
    await this.loadSexes();
  }

  async loadTipusDocuments() {
    this.tipusDocuments = await this.blEnum.list(
      'Udg.GausNET.Model.Generals.TipusDocumentIdentificatiu',
      this.dataService.current_language);
  }

  async loadSexes() {
    this.sexes = await this.blEnum.list(
      'Udg.GausNET.Model.Generals.Sexe',
      this.dataService.current_language);
  }

  validateDocumentIdentificatiu(control: AbstractControl) {
    switch (this.trasllat.alumne.tipusDocument) {
      case 1:
        return this.blTrasllat.validaDNI(this.trasllat.alumne.documentIdentificatiu).map(res => {
          return res ? null : {invalidDocumentIdenticatiu: true};
        });
      case 2:
        return this.blTrasllat.validaNIE(this.trasllat.alumne.documentIdentificatiu).map(res => {
          return res ? null : {invalidDocumentIdenticatiu: true};
        });
      default:
        return Observable.create(observer => {
          observer.next(null);
          observer.complete();
        });
    }
  }

  nacionalitatChange(newValue) {
    if (newValue != null && newValue.value) {
      this.trasllat.alumne.nacionalitat = newValue;
    } else {
      this.trasllat.alumne.nacionalitat = null;
    }
  }

  paisNaixementChange(newValue) {
    if (newValue != null && newValue.value) {
      this.trasllat.alumne.paisNaixement = newValue;
    } else {
      this.trasllat.alumne.paisNaixement = null;
    }
  }

  poblacioNaixementChange(newValue) {
    if (newValue != null && newValue.value) {
      this.trasllat.alumne.poblacioNaixement = newValue;
    } else {
      this.trasllat.alumne.poblacioNaixement = null;
    }
  }

  public isValid(): boolean {
    try {
      if (this.formulari == null) {
        return false;
      }
      if (this.formulari.form == null) {
        return false;
      }
      if (this.formulari.form.invalid) {
        return false;
      }
      if (this.tipusDocumentIdentificatiuInput.invalid) {
        this.tipusDocumentIdentificatiuInput.markAsDirty();
        return false;
      }
      if (this.utilitats.isNullOrEmpty(this.trasllat.alumne.paisNaixement)) {
        return false;
      }
      if (this.utilitats.isNullOrEmpty(this.trasllat.alumne.nacionalitat)) {
        return false;
      }
      if (this.trasllat.alumne.paisNaixementEspanya()) {
        if (this.utilitats.isNullOrEmpty(this.trasllat.alumne.poblacioNaixement)) {
          return false;
        }
      } else if (this.utilitats.isNullOrEmpty(this.trasllat.alumne.poblacioNaixementText)) {
        return false;
      }
    } catch (ex) {
      console.log('Error a isValid()');
      console.log(ex.Message);
    }
    return true;
  }

  public async continua() {
    try {
      this.stepper.next();
      if (!this.stepPerformed) {
        this.dataService.maxStep++;
        this.stepPerformed = true;
      }
      if (!this.trasllat.isnew) {
        this.trasllat = await this.blTrasllat.save(this.trasllat);
        this.dataService.trasllat = this.trasllat;
      }
    } catch (ex) {
        console.log(ex.Message);
        this.snackBar.open(ex.Message, null, {
            duration: 10000,
          });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dades-personals/dades-personals.component.ts